import React, { useState } from 'react';
export function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  return <footer className="bg-dark-900 text-white pt-16 pb-8" data-id="element-15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12" data-id="element-17">
          <div data-id="element-18">
            <h3 className="font-serif text-2xl font-bold text-coral-400 mb-4" data-id="element-19">
              Protocolo Cortisol OFF
            </h3>
            <p className="text-gray-400 max-w-sm" data-id="element-20">
              Desinflama tu cuerpo y recupera tu energía en 14 días con el
              método Circadian Stacking.
            </p>
          </div>
          <div className="flex flex-col md:items-end justify-center" data-id="element-21">
            <div className="flex flex-wrap gap-4 md:gap-6 text-sm text-gray-400" data-id="element-22">
              <button onClick={() => setShowTerms(!showTerms)} className="hover:text-white transition-colors" data-id="element-23">
                Términos y Condiciones
              </button>
              <button className="hover:text-white transition-colors" data-id="element-24">
                Política de Privacidad
              </button>
              <button className="hover:text-white transition-colors" data-id="element-25">
                Política de Reembolso
              </button>
              <button className="hover:text-white transition-colors" data-id="element-26">
                Contacto
              </button>
            </div>
          </div>
        </div>

        {showTerms && <div className="bg-dark-800 p-6 rounded-lg mb-12 text-xs text-gray-400 leading-relaxed border border-gray-700" data-id="element-27">
            <h4 className="font-bold text-white mb-2" data-id="element-28">
              Términos y Condiciones
            </h4>
            <p className="mb-2" data-id="element-29">
              Al realizar tu compra, aceptas nuestros términos de servicio. El
              acceso al producto es personal e intransferible.
            </p>
            <p data-id="element-30">
              Política de reembolso: 7 días desde la fecha de compra para
              solicitar reembolso completo enviando email a
              soporte@protocolocortisoloff.com
            </p>
          </div>}

        <div className="border-t border-gray-800 pt-8 text-xs text-gray-500 space-y-4 text-center md:text-left" data-id="element-31">
          <p data-id="element-32">
            Este sitio no es parte de Facebook ni de Meta Platforms, Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de META PLATFORMS, INC.
          </p>
          <p data-id="element-33">
            AVISO LEGAL: Los resultados mencionados en esta página son ejemplos
            de lo que algunos clientes han logrado. Los resultados no son
            típicos. Los resultados individuales variarán según el esfuerzo,
            experiencia, conocimiento y nivel de compromiso de cada persona.
          </p>
          <p data-id="element-34">
            Este producto es de carácter informativo y no reemplaza el consejo
            médico profesional. Consulta a tu médico antes de iniciar cualquier
            protocolo de salud.
          </p>
          <div className="pt-4 text-center" data-id="element-35">
            © 2025 Protocolo Cortisol OFF. Todos los derechos reservados.
          </div>
        </div>
      </div>
    </footer>;
}